import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import "./Mobile_recharge_plan_card.css";

function Mobile_recharge_plan_card({ tagClassName = "", tagName }) {
    const location = useLocation();

    // Check if current path is "/mobile-prepaid-recharge"
    const isPrepaidRechargePage = location.pathname === "/mobile-prepaid-recharge";
    const [isExpanded, setIsExpanded] = useState(false);

    const fullText = `True 5G Unlimited Plan | Data: Unlimited 5G + 2 GB/day | Voice: Unlimited Calls | 
    SMS: 100 SMS/day | Get Unlimited 5G Data for eligible subscribers. Enjoy seamless 5G connectivity, 
    fast speeds, and reliable performance. Perfect for heavy data users and streaming lovers.`;

    const shortText = `True 5G Unlimited Plan | Data: Unlimited 5G + 2 GB/day | Voice: Unlimited Calls | 
    SMS: 100 SMS/day | Get Unlimited 5G Data for eligible subscribers...`;

    return (
        <section className='Mobile_recharge_plan_card_holder Mobile_recharge_plan_card'>
            <div className="plan_card_holder">

                <div className="plan_heading_holder">
                    <div className="row">
                        <div className="col-md-3 col-sm-3 col-3">
                            <div className="text_holder">
                                <h4 className='amount_text'>₹ 19</h4>
                            </div>
                        </div>

                        <div className="col-md-3 col-sm-3 col-3">
                            <div className="text_holder">
                                <div>
                                    <p>Validity</p>
                                    <h6>Existing Active plan</h6>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 col-sm-3 col-3">
                            <div className="text_holder">
                                <div>
                                    <p>Data</p>
                                    <h6>1 GB</h6>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 col-sm-3 col-3">
                            <div className="text_holder">
                                {!isPrepaidRechargePage && (
                                    <Link to={"/mobile-prepaid-recharge"}>
                                        <div className="arrow_circle">
                                            <FontAwesomeIcon className='arrow_icon' icon={faAngleRight} />
                                        </div>
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Conditional tag */}
                    {tagName && (
                        <div className={`card_offer_tag_hodler ${tagClassName}`}>
                            <p>{tagName}</p>
                        </div>
                    )}
                </div>

                <div className="plan_description_holder">
                    <p>
                        {isExpanded ? fullText : shortText}
                        <span
                            className="view_toggle"
                            onClick={() => setIsExpanded(!isExpanded)}
                        >
                            {isExpanded ? " View Less" : " View More"}
                        </span>
                    </p>
                </div>
            </div>

            <div className="note_holder">
                <div className='note_text_holder'>
                    <div className="note_text_holder">
                           <div className="img_holder">

                        <img src="/assets/images/services/recharge_logo/five_g.png" alt="" className='sim_img' />
                           </div>
                    </div>
                    <div className="text_holder">
                        <p>Unlimited True 5G Data |</p>
                    </div>
                </div>

                <div className='note_text_holder'>
                    <div className="img_holder">
                        <img src="/assets/images/services/recharge_logo/tata_play.png" alt="" className='sim_img' />
                    </div>
                    <div className="text_holder">
                        <p>Jio Cinema | + 2</p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Mobile_recharge_plan_card;
